// extracted by mini-css-extract-plugin
export default {"root":"root_zI1bCft","root_hasLink":"root_hasLink_z3kqGt0"};